import React, { useCallback, useContext, useMemo } from "react";
import { IAdminAttendanceViewProps } from "../attendance.types";
import StatCards from "../../common/stat-cards/stat-cards";
import WeeklyTrendChart from "./weekly-trend-chart";
import MonthlyAttendanceChart from "../component/monthly-attendance-chart";
import AttendanceTable from "../component/attendance-table";
import server from "../../../server";
import AttendanceSearchContext from "../AttendanceContext";
import '../../../styles/component/attendance.scss'
import { fetchEmployeeAttendance } from "./actions";


const AdminAttendanceSummaryView: React.FC<IAdminAttendanceViewProps> = (props) => {




    return (
        <div className={'admin-attendance'}>
            <StatCards data={props.cardData} loading={props.isSummaryLoading} size={"small"}/>

            <div className={'admin-attendance__chart-wrapper'}>
                <MonthlyAttendanceChart data={props.chartData.monthlyTrend} isLoading={props.isChartLoading}/>
                <WeeklyTrendChart data={props.chartData.dayOfWeekPattern} isLoading={props.isChartLoading}/>
            </div>
            <AttendanceTable
                fetchAttendanceApi={fetchEmployeeAttendance}
                isActionVisible={true}
                showPunchOnClick={true}
            />
        </div>
    )
}

export default AdminAttendanceSummaryView;
